import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-second-director-signature',
  templateUrl: './second-director-signature.component.html',
  styleUrls: ['./second-director-signature.component.scss']
})
export class SecondDirectorSignatureComponent implements OnInit {

  constructor(public router: Router) { }
  onSubmit() {

    if ($("#obaoform").valid()) {
      this.router.navigate(['/second-director-company-constitution']);
    }
  }

  ngOnInit() {

    $("#obaoform").validate({
      rules: {
        img_sign_second: {
          required: true,
          extension: "jpg|jpeg",
          maxsize: 5000000
        }
      },
      messages: {
        img_sign_second: {
          required: "Please select an image",
          extension: "Please select an image with format .jpg or .jpeg",
          maxsize: "File size must not exceed 5Mb each. On your camera application, go to Setting and to select lower resolutions"
        }
      },
      errorPlacement: function (error, element) {

        if (element.attr("name") == "img_sign_second") {
          error.appendTo("#img_sign_second_error_container");
        }
      },
      submitHandler: function (form) {
        // $("#btn-next").prop("disabled", true);
      }


    });

    //validate when user make an input
    $(document).on("input", function () {
      $("#obaoform").valid();
    })
    /*   DCI update (16th June 2020) : Add javascript for thumbnail image start*/
    function handleFileSelect(e) {
      var file = e.target.files[0];
      var fileName = file.name;
      var ext = fileName.split(".").pop();
      var filesize = file.size;//check filesize
      var maxsize = 5000000;//5mb maxsize
      // Declare variable of the id of changed input files 
      var id = $(this).attr('id');
      // Declare the id of image to be replace it source
      var upload_img = 'thumbnail-container-sign';

      // console.log("pop:" + ext);
      // console.log("size:" + filesize);
      //image resizing
      $.canvasResize(file, {
        width: 500,
        height: 0,
        crop: false,
        quality: 100,
        callback: function (data) {
          //show image thumbnail
          if(((ext.toLowerCase()== "jpg") || (ext.toLowerCase()== "jpeg")) && filesize <= maxsize ){
            $("#" + upload_img).attr('src', data);
            $('#' + upload_img).css("height", "auto");
            $('#file_text').text("Re-upload");
            $('#output_img_sign_second').val(data);
        // console.log(data);
          }else{
            $("#" + upload_img).attr('src', null);
            $('#' + upload_img).css("height", "0px");
          }
        }
      });

    }
    $('#img_sign_second').on('change', handleFileSelect);

    /*   DCI update (16th June 2020) : Add javascript for thumbnail image end*/
  }

}
